import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GroupHasRoleInOrganisationService extends RestfulService<Models.GroupHasRoleInOrganisation> {

  constructor(public restService: RestService) {
    super(Models.GroupHasRoleInOrganisation);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('group-has-role-in-organisations');
  }

}
